import React, { ReactNode } from 'react'
import { Link, Outlet, useMatch, useResolvedPath } from 'react-router-dom'

import { Box, Button, Image, Text } from '@myxplor/stardust'

import { clearAuthToken } from '../modules/auth'

import starmapImage from '~/src/assets/starmap.png'

interface Props {
  user: Papi.User
}

const MenuItem = ({ children, to }: { children: ReactNode; to: string }) => {
  const resolved = useResolvedPath(to)
  const match = useMatch({ path: resolved.pathname, end: true })

  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <Box
        borderLeft="5px solid"
        borderColor={match ? 'primary' : 'transparent'}
        hoverStyle={({ theme }) => ({ backgroundColor: theme.colors.lowestEmphasis })}
        paddingX="small"
        paddingY="xxsmall"
        transition="background .2s">
        <Text color={match ? 'primary' : 'lowEmphasis'} prefab="bodyAlt" weight={match ? 'bold' : undefined}>
          {children}
        </Text>
      </Box>
    </Link>
  )
}

const Navigation = ({ user }: Props) => {
  const onLogout = () => {
    clearAuthToken()
    window.location.pathname = '/login'
  }
  return (
    <Box
      backgroundColor="foreground"
      boxShadow="2dp"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      maxWidth={200}
      width={1}>
      <Box>
        <Box padding="small" paddingBottom="small">
          <Image width={1} src={starmapImage} />
        </Box>

        <Box borderColor="transparent" borderLeft="5px solid" padding="small" paddingBottom="xxsmall">
          <Text prefab="overline">Onboarding</Text>
        </Box>
        <Box paddingBottom="small">
          <MenuItem to="/accounts">Accounts</MenuItem>
          <MenuItem to="/services">Services</MenuItem>
        </Box>

        {user.admin && (
          <Box>
            <Box borderColor="transparent" borderLeft="5px solid" padding="small" paddingBottom="xxsmall">
              <Text prefab="overline">Admin</Text>
            </Box>
            <MenuItem to="/features">Features</MenuItem>
            <MenuItem to="/packages">Packages</MenuItem>
            <MenuItem to="/users">Users</MenuItem>
          </Box>
        )}
      </Box>
      <Box padding="small">
        <Button fill variant="outline" onClick={onLogout}>
          Logout
        </Button>
      </Box>
    </Box>
  )
}

const DashboardLayout = ({ user }: Props) => {
  return (
    <Box display="flex" flexDirection="column" height="100vh" width={1}>
      <Box backgroundColor="lowestEmphasis" display="flex" flexGrow={1} width={1}>
        <Navigation user={user} />
        <Box
          display="flex"
          flexGrow={1}
          justifyContent="center"
          overflowX="hidden"
          overflowY="auto"
          padding="large">
          <Box maxWidth={1024} width={1}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default React.memo(DashboardLayout)
